/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import * as React from 'react';

import { Spinner } from '../../components/Spinner';

export const DocusignRedirectionComponent = (): JSX.Element => {
    const params = new URLSearchParams(location.search);
    const callBackEvent = params.get('event');

    React.useEffect((): void => {
        window.parent.postMessage(JSON.stringify(callBackEvent), window.location.origin);
    }, [callBackEvent]);

    // if a new tab was opened and redirection component was triggered which it shouldn't be, we then close the window to avoid seeing a blank page with spinner
    window.close();

    return (
        <div style={{ height: '100vh' }}>
            <Spinner />
        </div>
    );
};
